const resources = {
  "en": {
    "incomeList": {
      "title": "Income",
      "pageDescription": "Track recent income, keep the monthly view tight, and manage incoming cash from one workspace.",
      "filterSummary": "Showing income activity for {{month}}",
      "pagination": {
        "pageSizeLabel": "Rows shown",
        "allForPeriod": "All for period"
      },
      "metrics": {
        "total": {
          "label": "Total income",
          "supporting": "Filtered month total"
        },
        "transactions": {
          "label": "Transactions",
          "supporting": "Posted income rows in scope"
        },
        "categories": {
          "label": "Categories",
          "supporting": "Unique income categories in view"
        },
        "average": {
          "label": "Average income",
          "supporting": "Average amount per income row"
        }
      },
      "sections": {
        "recent": {
          "description": "Latest income rows in the current month scope."
        },
        "summary": {
          "description": "Category breakdown for all income rows that match the current month and category filters.",
          "scopeEmpty": "Summary follows the current month and category filters.",
          "scopeAllVisible": "Summary matches all {{total}} filtered income rows currently in view.",
          "scopePaginated": "Summary covers all {{total}} filtered income rows. The list is showing {{rangeStart}}-{{rangeEnd}} on this page."
        }
      },
      "recentTitle": "Recent Incomes",
      "actions": {
        "add": "+ Add",
        "edit": "Edit",
        "assign": "Assign to group",
        "delete": "Delete",
        "cancel": "Cancel",
        "save": "Save",
        "deleteConfirmTitle": "Delete this income?",
        "deleteConfirmDescription": "This action cannot be undone.",
        "menuAria": "Income actions"
      },
      "list": {
        "empty": "No income records",
        "unnamed": "Unnamed"
      },
      "modals": {
        "addTitle": "Add Income",
        "assignTitle": "Assign to Group",
        "selectGroupPlaceholder": "Select group"
      },
      "messages": {
        "loadError": "❌ Failed to load incomes",
        "deleteSuccess": "✅ Income deleted",
        "errorWithReason": "❌ {{error}}",
        "assigned": "✅ Assigned",
        "categoriesLoadError": "❌ Failed to load categories",
        "groupsLoadError": "❌ Failed to load groups"
      }
    }
  },
  "uk": {
    "incomeList": {
      "title": "Дохід",
      "pageDescription": "Відстежуйте недавні доходи, тримайте місячний зріз компактним і керуйте вхідним кешфлоу з одного простору.",
      "filterSummary": "Показано доходи за {{month}}",
      "pagination": {
        "pageSizeLabel": "Показувати рядків",
        "allForPeriod": "Усі за період"
      },
      "metrics": {
        "total": {
          "label": "Усього доходу",
          "supporting": "Підсумок за вибраний місяць"
        },
        "transactions": {
          "label": "Транзакції",
          "supporting": "Проведені доходи у вибірці"
        },
        "categories": {
          "label": "Категорії",
          "supporting": "Унікальні категорії доходів у вибірці"
        },
        "average": {
          "label": "Середній дохід",
          "supporting": "Середня сума одного запису доходу"
        }
      },
      "sections": {
        "recent": {
          "description": "Останні записи доходів у межах вибраного місяця."
        },
        "summary": {
          "description": "Розподіл по категоріях для всіх доходів, що відповідають поточним фільтрам місяця та категорії.",
          "scopeEmpty": "Підсумок враховує поточні фільтри місяця та категорії.",
          "scopeAllVisible": "Підсумок збігається з усіма {{total}} відфільтрованими доходами, які зараз показані.",
          "scopePaginated": "Підсумок охоплює всі {{total}} відфільтровані доходи. У списку на цій сторінці показано {{rangeStart}}-{{rangeEnd}}."
        }
      },
      "recentTitle": "Останні доходи",
      "actions": {
        "add": "+ Додати",
        "edit": "Редагувати",
        "assign": "Призначити в групу",
        "delete": "Видалити",
        "cancel": "Скасувати",
        "save": "Зберегти",
        "deleteConfirmTitle": "Видалити цей дохід?",
        "deleteConfirmDescription": "Цю дію не можна скасувати.",
        "menuAria": "Дії з доходом"
      },
      "list": {
        "empty": "Немає записів про доходи",
        "unnamed": "Без назви"
      },
      "modals": {
        "addTitle": "Додати дохід",
        "assignTitle": "Призначити до групи",
        "selectGroupPlaceholder": "Виберіть групу"
      },
      "messages": {
        "loadError": "❌ Не вдалося завантажити доходи",
        "deleteSuccess": "✅ Дохід видалено",
        "errorWithReason": "❌ {{error}}",
        "assigned": "✅ Призначено",
        "categoriesLoadError": "❌ Не вдалося завантажити категорії",
        "groupsLoadError": "❌ Не вдалося завантажити групи"
      }
    }
  }
};

export default resources;
